// Cadence AI assistant is temporarily disabled (test mode).
// Original implementation backed up at src/components/_disabled/AIHelpChat.tsx.
// Restore instructions: see USERGUIDE_REMOVED_SECTIONS.md → "Cadence AI Assistant".
import { Bot } from 'lucide-react';

export function AIHelpChat() {
  return (
    <div className="h-full min-h-[400px] flex flex-col items-center justify-center border rounded-lg bg-muted/30 p-6 text-center">
      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3">
        <Bot className="h-6 w-6 text-primary" />
      </div>
      <h3 className="font-semibold mb-1">Cadence is offline</h3>
      <p className="text-sm text-muted-foreground max-w-sm">
        Our AI assistant is temporarily disabled while we put it through additional testing.
        It will return soon.
      </p>
    </div>
  );
}
